import { SetState, GetState } from 'zustand';
import { VIEWS_MAP } from '../router/constants';

export interface IRedirectionSlice {
  redirectAfterLoginTo: string;
  setRedirection: (redirectAfterLoginTo: string) => void;
  getRedirection: () => string;
  searchParams: string;
  setSearchParams: (paramString: string) => void;
  resetRedirectionSlice: () => void;
}

const createRedirectionSlice = (set: SetState<IRedirectionSlice>, get: GetState<IRedirectionSlice>) => ({
  redirectAfterLoginTo: '',
  searchParams: '',
  resetRedirectionSlice: () => {
    set({
      redirectAfterLoginTo: '',
      searchParams: '',
    });
  },
  setRedirection: (redirectAfterLoginTo: any) => {
    const viewsToAvoidRedirect = [`/${VIEWS_MAP.RECOVERY}`, `/${VIEWS_MAP.ACCOUNTANT_ONBOARDING}`];
    if (viewsToAvoidRedirect.includes(redirectAfterLoginTo)) return;
    set({
      redirectAfterLoginTo,
    });
  },
  setSearchParams: (params: string) => {
    set({ searchParams: params });
  },
  getRedirection: () => get().redirectAfterLoginTo,
});

export default createRedirectionSlice;
